import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { BreadcrumbLine } from '../../../../../../components/BreadcrumbLine/BreadcrumbLine';
import { ListMenuRoutes } from '../../../../../../components/ListMenu/ListMenuRoutes';
import { ModalConfirm } from '../../../../../../components/Modals/ModalConfirm';
import { isStatusSucess } from '../../../../../../helpers/helpers';
import { useForm } from '../../../../../../hooks/useForm';
import { useLang } from '../../../../../../language';
import { LoaderForm } from './LoaderForm';
import { DatosGenerales } from './DatosGenerales/Index';
import { AlquilerServices } from '../services/alquileres.service';
import { Facturas } from './Facturas';

const Alquiler = ({ pathName }: any) => {

    let params = useParams()

    const [currentTarifa, setcurrentTarifa] = useState<any>({});

    const idpedido: string = String(params.id) || ''

    const nuevo = idpedido === 'nuevo'

    const Lang = useLang()

    const [formInscripcion, handleInputInscripcion, handleFormInscripcion, resetFormInscripcion] = useForm({
        idpersona: '',
        idproducto: '',
        idpersonaentidad: '',
        idcondicionpago: '',
        ideventotarifa: '',
        observaciones: '',
        nombre_completo: '',
        abona: 'P',
        comunicar: [],
        facturar: [],
        fechadesde: '',
        fechahasta: '',
        idproductotarifa: '',
        idpedido: idpedido || '',
        nombrepersona: '',
    })

    const BreadcrumbLineItems = [
        {
            title: Lang('ALQUILERES'),
            link: '/alquiler-aparatos-admin/alquileres'
        },
        {
            title: `${Lang('APARATO')}: ${formInscripcion.producto || ''}`,
            link: `/${idpedido}`
        }
    ]

    const [fetchPedidoGET, fetchPedidoGETData] = AlquilerServices.GET(idpedido)

    const handleFetchSuccess = () => {

        resetFormInscripcion()

        fetchPedidoGET()
    }

    useEffect(() => {

       handleFetchSuccess()

    }, [idpedido]);

    useEffect(() => {

        if (isStatusSucess(fetchPedidoGETData.status)) {            

            handleFormInscripcion({
                ...formInscripcion,
                ...fetchPedidoGETData.data,
                nombre_completo: fetchPedidoGETData.data?.nombrepersona,
            })

            setcurrentTarifa({
                totalimportebase: Number(fetchPedidoGETData.data?.pedidos_productos?.[0]?.precio || 0),
                importeiva: Number(fetchPedidoGETData.data?.pedidos_productos?.[0]?.iva?.porcentajeiva || 0),
                totalimportetotal: Number(fetchPedidoGETData.data?.pedidos_productos?.[0]?.importetotal || 0),
                idiva: fetchPedidoGETData.data?.pedidos_productos?.[0]?.idiva || '',
            })

        }
    }, [fetchPedidoGETData]);

    const listMenu: any = {
        datosGenerales: {
            title: Lang('DATOS_ALQUILER'),
            link: 'datos-generales',
        },
        facturas: {
            title: Lang('FACTURAS'),
            link: 'facturas',
        },
    }

    const [showConfirm_CHANGE_ESTADO, setshowConfirm_CHANGE_ESTADO] = useState<any>({
        value: false,
        payload: {}
    })

    const [flagactive, setflagactive] = useState(false);

    useEffect(() => {

        if (formInscripcion.idpedido && (formInscripcion.idpersona || formInscripcion.idpersonaentidad)) {

            setflagactive(true)
        }

    }, [formInscripcion]);

    return (

        <div className="container-fluid">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className='d-flex justify-content-between align-items-center mb-1 flex-wrap'>
                        <BreadcrumbLine BreadcrumbLineItems={BreadcrumbLineItems} />
                    </div>
                </div>

                {
                    !nuevo && <div className="col-lg-3 mb-4">

                        <ListMenuRoutes values={listMenu} />

                    </div>
                }

                <div className="col-lg-9 animate__animated animate__fadeInUp">

                    {
                        fetchPedidoGETData.loading || !flagactive ?
                            <div className="card p-3">
                                <LoaderForm />
                            </div>
                            :
                            <Routes>

                                <Route
                                    path='datos-generales'
                                    element={
                                        <DatosGenerales
                                            idpedido={idpedido}
                                            nuevo={nuevo}
                                            formInscripcion={formInscripcion}
                                            handleInputInscripcion={handleInputInscripcion}
                                            fetchPedidoGET={fetchPedidoGET}
                                            fetchPedidoGETData={fetchPedidoGETData}
                                            handleFormInscripcion={handleFormInscripcion}
                                            currentTarifa={currentTarifa}
                                            setcurrentTarifa={setcurrentTarifa}
                                            handleFetchSuccess={handleFetchSuccess}
                                        />
                                    }
                                />

                                <Route
                                    path='facturas'
                                    element={
                                        <Facturas
                                            idpedido={idpedido}
                                            formInscripcion={formInscripcion}
                                        />
                                    }
                                />

                                <Route
                                    path="*"
                                    element={<Navigate to='datos-generales' replace />}
                                />
                            </Routes>
                    }

                </div>
            </div>

            <ModalConfirm
                handleClose={() => setshowConfirm_CHANGE_ESTADO({ value: false, payload: {} })}
                show={showConfirm_CHANGE_ESTADO.value}
                // onClickOK={handleChangeEstadoEvento}
                messageHTML={
                    <h5 className='text-center fw-normal'>{Lang('PARRAFO_SEGURO_CAMBIAR_ESTADO_EVENTO_A')} {showConfirm_CHANGE_ESTADO.payload?.nombre}?</h5>
                }
                textOnClickOk={Lang('SI_CAMBIAR')}
            // fetchData={fetchInscripcionPATCHData}
            />

        </div>
    )
}

export default Alquiler;